require("!!/home/intellect/workspace/intellect/Warehouse/frontend/src/main/frontend/node_modules/script-loader/addScript.js")(require("!!/home/intellect/workspace/intellect/Warehouse/frontend/src/main/frontend/node_modules/raw-loader/index.js!/home/intellect/workspace/intellect/Warehouse/frontend/src/main/frontend/node_modules/chart.js/dist/chart.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/chart.js/dist/chart.min.js
// module id = 566
// module chunks = 3